import Axios from "axios";
import { authUrl, baseUrl, payrollUrl } from "../../config/globalVariables";

export const PayrollRequest = Axios.create({ baseURL: payrollUrl });
export const AuthRequest = Axios.create({
  baseURL: authUrl,
  withCredentials: true,
});
export const CoreRequest = Axios.create({ baseURL: baseUrl });
